import { ReactComponent as IconInfoCircle } from "@/assets/svgs/infoCircle.svg";
import { ReactComponent as ErrorInfoCircle } from "@/assets/svgs/exclamation-circle-solid-small.svg";

import PropTypes from "prop-types";

const ToggleSwitch = ({ item, labelText, callback }) => {
	return (
		<div className="flex-box flex-align-center flex-end">
			<div className="m-0 font-color-grey-60 font-weight-normal mr-1 custom-header__toggle-label">
				{labelText}
			</div>
			<label className="switch m-0">
				<input
					className="switch-checkbox"
					type="checkbox"
					checked={item.checked}
					onChange={callback}
					aria-label={labelText}
				/>
				<span className="slider round" />
			</label>
		</div>
	);
};

ToggleSwitch.propTypes = {
	item: PropTypes.shape({
		checked: PropTypes.bool.isRequired,
	}).isRequired,
	labelText: PropTypes.string.isRequired,
	callback: PropTypes.func.isRequired,
};

export const CustomHeadersToggle = ({
	isCustomHeadersEnabled = false,
	setIsCustomHeadersEnabled,
	customHeaderErrors = [],
	customHeadersData = [],
	customHeaderInputValues = {},
}) => {
	const handleToggle = () => {
		setIsCustomHeadersEnabled(
			(isCustomHeadersEnabled) => !isCustomHeadersEnabled
		);
	};

	const hasOneValidCustomHeader = () => {
		const validHeaders = customHeadersData.filter(header => {
			return !customHeaderErrors.some(error => {
				return error.cellId.startsWith(header.id + '_');
			});
		});
		return validHeaders.length > 0;
	}

	const hasInvalidCustomHeaderInput = () => {
		if(!customHeaderInputValues?.key || !customHeaderInputValues?.value){
			return true;
		}
		const hasValidInput = customHeaderErrors.some(error => {
			return error.cellId.startsWith("newKey_key") || error.cellId.startsWith("newValue_value");
		});
		return hasValidInput;
	}

	const shouldShowError = isCustomHeadersEnabled && (hasInvalidCustomHeaderInput() && !hasOneValidCustomHeader());

	return (
		<div className="flex-box flex-direction-column">
			<div className="flex-box flex-direction-row flex-space-between flex-align-center">
				<div className="custom-headers-toggle__header">
					Custom Headers
				</div>
				<ToggleSwitch
					item={{ checked: isCustomHeadersEnabled }}
					labelText={isCustomHeadersEnabled ? "Enabled" : "Disabled"}
					callback={handleToggle}
				/>
			</div>
			<div className="flex-box flex-direction-row flex-space-between flex-align-center">
				<div className="custom-headers__info">
					<IconInfoCircle />
					<div className="custom-headers__description">
						User-defined key-value pairs in API requests for extra,
						non-standard information.
					</div>
				</div>
				{shouldShowError && <div className="custom-headers__info--error">
					<ErrorInfoCircle className="DS__error__icon"/>
					<div className="custom-headers__description custom-headers__description--error">
						Please add at least one custom header below.
					</div>
				</div>}
			</div>
		</div>
	);
};

CustomHeadersToggle.propTypes = {
	isCustomHeadersEnabled: PropTypes.bool.isRequired,
	setIsCustomHeadersEnabled: PropTypes.func.isRequired,
	customHeaderErrors: PropTypes.array.isRequired,
	customHeadersData: PropTypes.array.isRequired,
	customHeaderInputValues: PropTypes.object.isRequired,
};
